import { styled } from '@zenbusiness/zui/styles';
import MuiSwitch from '@zenbusiness/zui/Switch';

export const SwitchStyle = ({ theme }) => ({
  width: '28px',
  height: '16px',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: theme.palette.text.primary,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.background.cyan.main,
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      },
      '& .MuiSwitch-thumb:before': {
        backgroundImage: 'none'
      }
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '12px',
    height: '12px',
    backgroundColor: theme.palette.fixed.black,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: '0',
      top: '0',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.background.grey.main
      )}" d="M19 13H5v-2h14v2z"/></svg>')`
    }
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    backgroundColor: theme.palette.background.grey.main,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
});

export const MuiSwitchStyled = styled(MuiSwitch)(SwitchStyle);
